import { Reveal, SectionHead } from "./Reveal";
import { CALENDAR_STEPS, CALENDAR_TRACKED } from "@/data/content";

const ComplianceCalendar = () => (
    <section id="calendar" className="py-24 sm:py-32 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHead
                eyebrow="Compliance Calendar"
                title="Compliance Calendar & Due-Date Management"
                sub="Never miss an important statutory compliance due date. Every obligation is identified, scheduled, reminded, filed and archived with proof."
            />

            <div className="mt-12 flex flex-wrap gap-2.5" data-testid="calendar-tracked-list">
                {CALENDAR_TRACKED.map((t) => (
                    <span key={t} className="px-4 py-2 rounded-full border border-white/10 bg-[#101D3F]/60 text-xs text-slate-300">
                        {t}
                    </span>
                ))}
            </div>

            <div className="mt-16 overflow-x-auto pb-4" data-testid="calendar-timeline">
                <div className="flex items-center min-w-[900px]">
                    {CALENDAR_STEPS.map((step, i) => (
                        <div key={step} className="flex items-center flex-1 last:flex-none">
                            <Reveal delay={i * 0.06} className="flex flex-col items-center text-center w-full">
                                <div className="w-11 h-11 rounded-full border border-sky-400/40 bg-[#0A1128] flex items-center justify-center font-mono2 text-xs text-sky-300">
                                    {String(i + 1).padStart(2, "0")}
                                </div>
                                <p className="mt-3 text-xs sm:text-sm text-slate-200 font-medium max-w-[110px]">{step}</p>
                            </Reveal>
                            {i < CALENDAR_STEPS.length - 1 && (
                                <div className="flex-1 h-px bg-gradient-to-r from-sky-400/50 to-white/10 mx-1 -mt-8" />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default ComplianceCalendar;
